<template>
    <div id="app" class="fillcontain">
		    <router-view  v-if="isRouterAlive"></router-view>
    </div>
</template>

<script>
    export default {
    name:'app',
    provide(){
      return{
          reload:this.reload
      }
    },
    data() {
      return {
          isRouterAlive:true,
      }
    },
    mounted(){
      // 清除缓存
      // window.onbeforeunload = function (e) {
      //   const storage = window.localStorage;
      //   const session = window.sessionStorage;
      //   storage.clear()
      //   session.clear()
      // }
    },
    methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function(){
            this.isRouterAlive = true
        })
      },
    }
    }
</script>

<style lang="less">
	@import './style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue